var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _mask, _path, _path2, _rect8, _rect9, _path3, _path4, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgTeamsRedirectLogoHeader = function SvgTeamsRedirectLogoHeader(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 304,
    height: 304,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.25,
    x: 24,
    y: 24,
    width: 256,
    height: 256,
    rx: 55.727,
    fill: "#fff",
    fillOpacity: 0.05
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 0.719,
    y: 0.719,
    width: 302.561,
    height: 302.561,
    rx: 65.457,
    stroke: "#fff",
    strokeOpacity: 0.05,
    strokeWidth: 1.439
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 43.948,
    y: 43.948,
    width: 216.104,
    height: 216.104,
    rx: 46.891,
    fill: "#fff",
    fillOpacity: 0.05
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 63.896,
    y: 63.896,
    width: 176.208,
    height: 176.208,
    rx: 38.234,
    fill: "#fff",
    fillOpacity: 0.05
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 64.312,
    y: 64.312,
    width: 175.377,
    height: 175.377,
    rx: 37.818,
    stroke: "#fff",
    strokeOpacity: 0.05,
    strokeWidth: 0.831
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 78.857,
    y: 71.376,
    width: 146.286,
    height: 143.792,
    rx: 22.442,
    fill: "#fff",
    fillOpacity: 0.05
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 79.273,
    y: 71.792,
    width: 145.455,
    height: 142.961,
    rx: 22.026,
    stroke: "url(#teams-redirect-logo-header_svg__a)",
    strokeOpacity: 0.05,
    strokeWidth: 0.831
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "teams-redirect-logo-header_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.13 63.896c-21.116 0-38.234 17.118-38.234 38.234v92.26c0 21.115 17.118 38.233 38.234 38.233h99.74c21.116 0 38.234-17.118 38.234-38.234V102.13c0-21.116-17.118-38.234-38.234-38.234h-99.74Zm-.831 8.312c-13.313 0-24.104 10.791-24.104 24.104v99.74c0 13.312 10.792 24.104 24.104 24.104h101.402c13.313 0 24.104-10.792 24.104-24.104v-99.74c0-13.313-10.791-24.104-24.104-24.104H101.299Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.13 63.896c-21.116 0-38.234 17.118-38.234 38.234v92.26c0 21.115 17.118 38.233 38.234 38.233h99.74c21.116 0 38.234-17.118 38.234-38.234V102.13c0-21.116-17.118-38.234-38.234-38.234h-99.74Zm-.831 8.312c-13.313 0-24.104 10.791-24.104 24.104v99.74c0 13.312 10.792 24.104 24.104 24.104h101.402c13.313 0 24.104-10.792 24.104-24.104v-99.74c0-13.313-10.791-24.104-24.104-24.104H101.299Z",
    fill: "#fff",
    fillOpacity: 0.05
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.727 102.13c0-20.657 16.746-37.403 37.403-37.403v-1.662c-21.575 0-39.065 17.49-39.065 39.065h1.662Zm0 92.26v-92.26h-1.662v92.26h1.662Zm37.403 37.402c-20.657 0-37.403-16.746-37.403-37.402h-1.662c0 21.574 17.49 39.064 39.065 39.064v-1.662Zm99.74 0h-99.74v1.662h99.74v-1.662Zm37.403-37.403c0 20.657-16.746 37.403-37.403 37.403v1.662c21.575 0 39.065-17.49 39.065-39.065h-1.662Zm0-92.259v92.259h1.662V102.13h-1.662ZM201.87 64.727c20.657 0 37.403 16.746 37.403 37.403h1.662c0-21.575-17.49-39.065-39.065-39.065v1.662Zm-99.74 0h99.74v-1.662h-99.74v1.662ZM78.026 96.312c0-12.854 10.42-23.273 23.273-23.273v-1.663c-13.772 0-24.935 11.164-24.935 24.936h1.662Zm0 99.74v-99.74h-1.662v99.74h1.662Zm23.273 23.273c-12.854 0-23.273-10.42-23.273-23.273h-1.662c0 13.771 11.163 24.935 24.935 24.935v-1.662Zm101.402 0H101.299v1.662h101.402v-1.662Zm23.273-23.273c0 12.853-10.42 23.273-23.273 23.273v1.662c13.772 0 24.935-11.164 24.935-24.935h-1.662Zm0-99.74v99.74h1.662v-99.74h-1.662Zm-23.273-23.273c12.853 0 23.273 10.42 23.273 23.273h1.662c0-13.772-11.163-24.936-24.935-24.936v1.663Zm-101.402 0h101.402v-1.663H101.299v1.663Z",
    fill: "#fff",
    fillOpacity: 0.05,
    mask: "url(#teams-redirect-logo-header_svg__b)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 78.857,
    y: 71.376,
    width: 146.286,
    height: 140.468,
    rx: 22.442,
    fill: "#fff",
    fillOpacity: 0.05
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 79.273,
    y: 71.792,
    width: 145.455,
    height: 139.636,
    rx: 22.026,
    stroke: "url(#teams-redirect-logo-header_svg__c)",
    strokeOpacity: 0.05,
    strokeWidth: 0.831
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.454 119.851v5.551l-13.31-13.31 2.789-2.768 10.521 10.527Zm5.552 5.551h-5.552l13.311 13.311 2.777-2.777-10.536-10.534Zm31.57-10.524 2.774-2.774-26.597-26.598-2.774 2.774 10.509 10.525h-6.352l-7.337-7.33-2.777 2.774 4.568 4.568h-3.179v20.641h20.641v-3.176l4.568 4.568 2.774-2.778-7.342-7.357v-6.353l10.524 10.516Zm-35.733-17.462-2.774 2.778 2.977 2.976 2.774-2.777-2.977-2.977Zm23.621 23.621-2.765 2.774 2.976 2.977 2.777-2.774-2.988-2.977Zm-29.578-17.664-2.774 2.774 7.342 7.345v-5.554l-4.568-4.565Zm22.03 22.029h-5.552l7.346 7.343 2.774-2.775-4.568-4.568Z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M115.213 196.597h2.906V188.2c0-.705.12-1.303.361-1.795.25-.5.603-.879 1.058-1.138.456-.268.992-.402 1.608-.402.285 0 .544.018.776.054.241.027.42.067.536.12v-2.705a3.107 3.107 0 0 0-.428-.067 3.869 3.869 0 0 0-.576-.04c-.813 0-1.505.241-2.076.723-.572.473-.969 1.125-1.192 1.955h-.067v-2.41h-2.906v14.102Zm14.42.255c.625 0 1.21-.098 1.754-.295a5.01 5.01 0 0 0 1.487-.857 4.748 4.748 0 0 0 1.071-1.312h.067v2.209h2.906v-9.709c0-.947-.232-1.768-.696-2.465-.464-.696-1.116-1.236-1.955-1.62-.84-.384-1.835-.576-2.987-.576-1.152 0-2.147.187-2.987.562-.839.375-1.495.889-1.968 1.541a4.231 4.231 0 0 0-.817 2.183l-.014.147h2.733l.026-.121c.125-.562.438-1.022.938-1.379.509-.357 1.178-.536 2.009-.536.902 0 1.593.223 2.076.67.491.437.736 1.044.736 1.821v4.206c0 .607-.16 1.156-.482 1.647a3.241 3.241 0 0 1-1.286 1.138c-.535.277-1.142.416-1.821.416-.777 0-1.402-.179-1.875-.536-.464-.357-.696-.848-.696-1.473v-.014c0-.607.232-1.089.696-1.446.473-.366 1.143-.572 2.009-.616l4.942-.308v-2.036l-5.317.308c-1.67.098-2.964.509-3.884 1.232-.92.723-1.38 1.701-1.38 2.933v.027c0 .839.197 1.58.59 2.223a4.095 4.095 0 0 0 1.66 1.5c.706.357 1.527.536 2.465.536Zm13.241 4.46c.929 0 1.719-.139 2.371-.415a4.024 4.024 0 0 0 1.687-1.3c.474-.589.884-1.375 1.233-2.357l5.263-14.745h-3.067l-3.75 12.12.509-.656h-.723l.522.656-3.75-12.12h-3.147l5.129 14.116-.227.669c-.242.679-.567 1.134-.978 1.367-.402.241-.942.361-1.621.361-.196 0-.379-.013-.549-.04a9.991 9.991 0 0 1-.415-.054v2.264a8.356 8.356 0 0 0 1.513.134Zm19.255-4.433c1.143 0 2.148-.219 3.014-.657.875-.446 1.576-1.044 2.102-1.794.536-.75.853-1.598.951-2.545l.014-.094h-2.786l-.027.108c-.169.758-.531 1.375-1.085 1.848-.553.464-1.276.696-2.169.696-.741 0-1.393-.192-1.956-.576-.562-.384-1-.942-1.312-1.674-.313-.732-.469-1.611-.469-2.638v-.014c0-1 .152-1.866.456-2.598.312-.732.745-1.294 1.299-1.687.562-.402 1.218-.603 1.968-.603.947 0 1.688.254 2.224.763.544.5.888 1.094 1.031 1.782l.027.107h2.772v-.094a5.205 5.205 0 0 0-.884-2.464c-.5-.759-1.187-1.366-2.062-1.822-.875-.464-1.92-.696-3.134-.696-1.34 0-2.509.299-3.509.897-1 .589-1.777 1.433-2.331 2.531-.544 1.09-.817 2.38-.817 3.871v.013c0 1.5.273 2.799.817 3.898.545 1.098 1.317 1.946 2.317 2.544 1 .599 2.183.898 3.549.898Zm13.805-.027c.625 0 1.209-.098 1.754-.295a5.01 5.01 0 0 0 1.487-.857 4.748 4.748 0 0 0 1.071-1.312h.067v2.209h2.906v-9.709c0-.947-.232-1.768-.696-2.465-.464-.696-1.116-1.236-1.956-1.62-.839-.384-1.834-.576-2.986-.576-1.152 0-2.147.187-2.987.562-.839.375-1.495.889-1.968 1.541a4.222 4.222 0 0 0-.817 2.183l-.014.147h2.732l.027-.121c.125-.562.438-1.022.938-1.379.509-.357 1.178-.536 2.009-.536.901 0 1.593.223 2.075.67.491.437.737 1.044.737 1.821v4.206c0 .607-.161 1.156-.482 1.647a3.248 3.248 0 0 1-1.286 1.138c-.536.277-1.143.416-1.821.416-.777 0-1.402-.179-1.875-.536-.465-.357-.697-.848-.697-1.473v-.014c0-.607.232-1.089.697-1.446.473-.366 1.143-.572 2.009-.616l4.942-.308v-2.036l-5.317.308c-1.67.098-2.965.509-3.884 1.232-.92.723-1.38 1.701-1.38 2.933v.027c0 .839.197 1.58.59 2.223a4.088 4.088 0 0 0 1.66 1.5c.706.357 1.527.536 2.465.536Zm16.897.027c1.108 0 2.094-.183 2.96-.549.866-.367 1.545-.875 2.036-1.527.491-.652.737-1.411.737-2.277v-.013c0-1.009-.304-1.817-.911-2.425-.598-.607-1.621-1.075-3.067-1.406l-2.29-.522c-.75-.179-1.286-.415-1.607-.71a1.469 1.469 0 0 1-.483-1.112v-.013c0-.375.099-.701.295-.978.205-.276.5-.491.884-.642.384-.161.835-.242 1.353-.242.821 0 1.464.192 1.928.576.473.384.755.884.844 1.5l.013.108h2.719v-.161a4.058 4.058 0 0 0-.75-2.17c-.446-.643-1.071-1.152-1.875-1.527-.803-.375-1.763-.562-2.879-.562-1.081 0-2.032.178-2.853.536-.821.357-1.46.852-1.915 1.486-.456.634-.683 1.375-.683 2.223v.014c0 1.027.33 1.866.991 2.518.67.651 1.674 1.129 3.013 1.433l2.304.535c.759.179 1.286.411 1.58.697.304.277.456.643.456 1.098v.013c0 .375-.112.706-.335.992-.223.276-.545.491-.965.642-.41.143-.906.215-1.486.215-.884 0-1.576-.179-2.076-.536-.491-.366-.804-.871-.938-1.513l-.026-.121h-2.88l.014.121c.098.857.388 1.607.87 2.25.482.642 1.143 1.147 1.982 1.513.848.357 1.862.536 3.04.536Zm14.488-.014c.294 0 .571-.013.83-.04.259-.018.478-.04.656-.067v-2.25a7.34 7.34 0 0 0-.361.04 6.405 6.405 0 0 1-.429.014c-.616 0-1.08-.13-1.393-.389-.312-.268-.469-.759-.469-1.473v-7.902h2.652v-2.303h-2.652v-3.657h-2.986v3.657h-2.022v2.303h2.022v8.076c0 1.411.339 2.429 1.018 3.054.687.625 1.732.937 3.134.937Z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "teams-redirect-logo-header_svg__a",
    x1: 152,
    y1: 71.376,
    x2: 152,
    y2: 215.169,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "teams-redirect-logo-header_svg__c",
    x1: 78.857,
    y1: 71.376,
    x2: 225.143,
    y2: 211.844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.215,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#fff",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.745,
    stopColor: "#fff",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })))));
};

export default SvgTeamsRedirectLogoHeader;